import { gsap } from "gsap";
import $ from 'jquery';

function offCanvas() {
	const $offCanvas 	= $('.c-off-canvas');

	// Bail if no off canvas
	if( !$offCanvas.length ) return;

	$offCanvas.on('opened.zf.offcanvas', function() {
		animateMenu();
		animateFooter();
	});

	$offCanvas.on('closed.zf.offcanvas', function() {
		removeClasses();
	});

	function animateMenu() {
		const $nav 					= $('.c-off-canvas_nav'),
					$navItems   	= $nav.find('.menu-item'),
					staggerTime  	= 0.25;

		// Bail if no off canvas nav
		if( !$nav.length ) return;

		$navItems.each(function(index) {
			let $item = $(this);

			let navItemTimeline = gsap.timeline({onComplete: afterTimeline, onCompleteParams: [$item]});
			navItemTimeline
				.from( $item, staggerTime * (index + 1), { x: 500, alpha: 0, duration: 1 });

			function afterTimeline($item) {
				$item.addClass('animation-is-complete');
			}
		});
	}

	function animateFooter() {
		const $footer = $('.c-off-canvas_footer');

		// Bail if no off canvas footer is set
		if( !$footer.length ) return;

		let footerTimeline = gsap.timeline();
		footerTimeline
			.from( $footer, { y: 500, alpha: 0, duration: .5 }).delay(.25);
	}

	function removeClasses() {
		const $items = $('.c-off-canvas_nav .menu-item');

		$items.removeClass('animation-is-complete');
	}
}

export { offCanvas };